export const hourItems = Array.from({ length: 24 }, (_, index) => ({
  value: index,
  label: index.toString().padStart(2, '0'),
}));

export const minuteItems = Array.from({ length: 60 }, (_, index) => ({
  value: index,
  label: `${index.toString().padStart(2, '0')}`,
}));

export interface PickerProps {
  time: {
    startHour: number;
    setStartHour: (hour: number) => void;
    startMinute: number;
    setStartMinute: (minute: number) => void;
    stopHour: number;
    setStopHour: (hour: number) => void;
    stopMinute: number;
    setStopMinute: (minute: number) => void;
  };
  ledDays: number[];
  setShowPicker: (show: boolean) => void;
  onCancel: () => void;
  onSave: () => void;
}

export interface WeekProps {
  ledDays: number[];
  setLedDays: (days: number[]) => void;
  setShowPicker: (show: boolean) => void;
}
